import { graphql } from '@/gql';
import type { SendVerificationEmailMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendVerificationEmail = async ({ infoType, customerName, email }: SendVerificationEmailMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      infoType,
      customerName,
      email,
    },
    mutation: graphql(`
      mutation SendVerificationEmail($infoType: String!, $customerName: String!, $email: String!) {
        sendVerificationEmail(infoType: $infoType, customerName: $customerName, email: $email)
      }
    `),
  });

  return response.data?.sendVerificationEmail ?? false;
};
